import { jsx as r } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { C as e, P as l, R as m, T as d, A as v, a as f } from "../../index-iPWXV1sA.js";
import { c as g } from "../../cn-gv_k3DnN.js";
const u = m, A = d, N = v, R = f, P = i(
  ({
    className: t,
    align: n = "center",
    sideOffset: s = 4,
    disablePortal: a = !1,
    ...p
  }, c) => {
    const o = /* @__PURE__ */ r(
      e,
      {
        ref: c,
        align: n,
        sideOffset: s,
        className: g(
          "z-50 border border-(--color-popover-stroke) rounded-xl shadow-md bg-(--color-popover-bg) text-(--color-popover-content) outline-none origin-[--radix-popover-content-transform-origin]",
          t
        ),
        ...p
      }
    );
    return a ? o : /* @__PURE__ */ r(l, { children: o });
  }
);
P.displayName = e.displayName;
export {
  u as Popover,
  N as PopoverAnchor,
  R as PopoverClose,
  P as PopoverContent,
  A as PopoverTrigger
};
